// extracted by mini-css-extract-plugin
export default {"ColSty":"CurrentThirtyDaysIncome_ColSty__Dowz8","titleSty":"CurrentThirtyDaysIncome_titleSty__5Wag5"};